import { Component, OnInit } from '@angular/core';
import {ExcListConfig} from 'exc-controls';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcTab} from 'exc-tab';
import {ConfigComponent} from '../config/config.component';

@Component({
  selector: 'app-clientconfig',
  templateUrl: './client-config.component.html',
  styles: []
})
export class ClientConfigComponent extends ExcTranslation implements OnInit {
  clientListConfig: ExcListConfig = new ExcListConfig();
  clientListData: any;
  clientSearchValue = '';

  constructor(private excrest: ExcRestService) {
  super();
  const _self = this;
    _self.clientListConfig.OnSearch = (searchValue) => {
      _self.clientSearchValue = searchValue;
      _self.loadClients();
    };
    _self.clientListConfig.OnRefresh = (event) => {
      _self.loadClients();
    };
    _self.clientListConfig.OnPageChanged = (pageNo, event) => {
      _self.loadClients();
    };
    _self.clientListConfig.OnSelectionChanged = (selectedItems, event1) => {
    };
    _self.clientListConfig.selectFirstAfterInit = true;
  }

  ngOnInit() {
    const _self = this;
    _self.loadClients();
  }

  loadClients() {
    const _self = this;
    _self.clientListConfig.isLoading = true;
    _self.excrest.sget(_self.excrest.computeUrl('ClientR_List',
      {fts: _self.clientSearchValue}), ExcCoreModule.Guid.NewGuid(),
      {})
      .subscribe(response => {
        if (response.response.data !== undefined) {
          _self.clientListData = response.response.data;
          _self.clientListData =  response.response.data;
          _self.clientListConfig.paging = response.response.paging;
        }
        _self.clientListConfig.isLoading = false;
      });
  }

  openConfigurationTab(data) {
    const _self = this;
    new ExcTab(data.Mdt_Kbz, ConfigComponent, {
      data: data
    }, data.Mdt_Id, {Unique: true}, true, 'far fa-cog').Open();
  }
}
